var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon-close"),React.createElement("path",{"d":"M5.355 6.055L.7 1.4a.495.495 0 1 1 .7-.7l4.655 4.655L10.71.7a.495.495 0 0 1 .7.7L6.755 6.055l4.655 4.655a.495.495 0 0 1-.7.7L6.055 6.755 1.4 11.41a.495.495 0 0 1-.7-.7l4.655-4.655z","fill":"currentColor","fillRule":"nonzero","key":1})]);
}

IconClose.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = IconClose;

IconClose.default = IconClose;
